export const abbreviateMetricLabel = (label: string): string => {
  if (label.includes('mRSI')) return label;
  return label.replace(/[^A-Z|%|0-9|:]/g, '');
};
